const classNames = function classNames(...argu) {
    return argu.join(' ');
};

export default classNames;
